/** Construction plans from `Construction` on the application; every field is optional. */
interface IDetailsProps {
    sizeOfLand?: number | string;
    /** "Yes"/"No" — undefined when the application never answered. */
    willUseExistingBuildings?: string;
    constructionCompletionTime?: string;
    projectLifespan?: number | string;
    environmentalManagementPlans?: string;
}

function DetailCell({ label, value, className, valueClassName = "text-lg font-semibold" }: {
    label: string;
    value?: number | string;
    className?: string;
    valueClassName?: string;
}) {
    if (value === undefined || value === null || value === "") return null;
    return (
        <div className={className}>
            <span className="text-sm text-gray-500">{label}</span>
            <p className={valueClassName}>{value}</p>
        </div>
    );
}

export default function ConstructionDetails({
    sizeOfLand,
    willUseExistingBuildings,
    constructionCompletionTime,
    projectLifespan,
    environmentalManagementPlans,
}: IDetailsProps) {
    const hasDetails = [
        sizeOfLand,
        willUseExistingBuildings,
        constructionCompletionTime,
        projectLifespan,
        environmentalManagementPlans,
    ].some((value) => value !== undefined && value !== null && value !== "");

    return (
        <div>
            <h1 className="my-2 text-lg font-semibold text-[#3C1E03]">Construction Details</h1>
            {hasDetails ? (
                <div className="grid grid-cols-2 gap-8 bg-white shadow-sm rounded-2xl p-4">
                    <DetailCell label="Size of Land Required (in hectares)" value={sizeOfLand} />
                    <DetailCell label="Will existing buildings be used?" value={willUseExistingBuildings} />
                    <DetailCell label="Construction completion time." value={constructionCompletionTime} />
                    <DetailCell label="Project Lifespan" value={projectLifespan} />
                    <DetailCell
                        label="Describe environmental management plans"
                        value={environmentalManagementPlans}
                        className="col-span-2"
                        valueClassName="text-sm"
                    />
                </div>
            ) : (
                <div className="bg-white shadow-sm rounded-2xl p-4">
                    <p className="text-sm text-gray-500">
                        No construction details recorded for this application.
                    </p>
                </div>
            )}
        </div>
    );
}
